
import { TemplateClassFlag } from "../../dom-templates/TemplageClassFlag";
import { ClassFlag } from "../../dom-tools/ClassFlag";
import { ElementAttribute } from "../../dom-tools/ElementAttribute";
import { ElementSelector } from "../../dom-tools/ElementSelector";
import { ElementType } from "../../dom-tools/ElementType";
import { FilterAndSort } from "./FilterAndSort";
import { Filter } from "./filters/Filter";
import { FilterFactory } from "./filters/FilterFactory";
import { FilterGroup } from "./filters/FilterGroup";

export class Filters
{
  static filterElements( e:Element )
  {
    let filterSettings = Filter.setting.queryAll( e );    

    let combinedGroupSelector = FilterAndSort.combinedGroup.from( e );
    
    let combinedGroups:Element[] = [];

    if ( combinedGroupSelector )
    {
      combinedGroups = ElementSelector.parse( combinedGroupSelector ).queryAll( e );
    }

    filterSettings = filterSettings.filter(
      f => 
      {
        if ( ElementType.option.is( f ) )
        {
          let selectParent = ElementType.select.getParent( f );

          if ( ! selectParent )
          {
            return false;
          }

          let options = ElementType.option.queryAll( selectParent );

          return options[ selectParent.selectedIndex ] === f;
        } 
        
        return true;
      }
    );

    let filters = filterSettings.map( fs => FilterFactory.create( fs ) );

    filters = FilterGroup.groupFilters( filters );


    let elements = FilterAndSort.selector.queryValueAllIn( e ); 

    
    let filteredElements:Element[] = [];
    
    elements.forEach( 
      e => 
      {
        let filtered = Filter.isFiltered( e, filters );
        //console.log( "Is filtered:", filtered, e );
        
        TemplateClassFlag.invisible.setAs( e, ! filtered );

        if ( filtered )
        {
          filteredElements.push( e );
        }
      }
    );   

    combinedGroups.forEach(
      g => 
      {
        let elements = FilterAndSort.selector.queryValueAllIn( e, g );
        let hasVisible = elements.find( e => ! TemplateClassFlag.invisible.in( e ) );

        TemplateClassFlag.invisible.setAs( g, ! hasVisible );
      }
    )

    return filteredElements;

  }
}